import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';


import {AppComponent} from './app.component';

import {RouterModule} from '@angular/router';
import {DataTablesModule} from 'angular-datatables';
import {HttpClientModule} from '@angular/common/http';
import {SidebarComponent} from './sidebar/sidebar.component';
import {FooterComponent} from './footer/footer.component';
import {StudentComponent, StudentDialogBox} from './student/student.component';
import {TopmenuComponent} from './topmenu/topmenu.component';
import {SyllabusComponent} from './syllabus/syllabus.component';
import {GradeComponent} from './grade/grade.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MaterialModule} from './material.module';
import {SubjectComponent, UserDialogBox, PriceDialogBox} from './subject/subject.component';
import {ChaptersComponent} from './chapters/chapters.component';
import {TopicsComponent} from './topics/topics.component';
import {VedioComponent} from './vedio/vedio.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {RecordComponent} from './record/record.component';
import {GradesComponent} from './grades/grades.component';
import {SubjectsComponent} from './subjects/subjects.component';
import {SubscriptionComponent} from './subscription/subscription.component';
import {ParentsComponent} from './parents/parents.component';
import {LoginComponent, ExpiredDialogBox} from './login/login.component';
import {RedirectComponent} from './redirect/redirect.component';
import {ChaptertestComponent} from './chaptertest/chaptertest.component';
import {TopictestComponent} from './topictest/topictest.component';
import {ChatComponent} from './chat/chat.component';
import {AngularFireModule} from 'angularfire2';
import {AuthGuard} from './auth.guard';
import {AngularFireDatabaseModule} from 'angularfire2/database';
import {AngularFireAuthModule} from 'angularfire2/auth';
import {environment} from '../environments/environment';
import {NotificationComponent} from './notification/notification.component';
import {UsersComponent} from './users/users.component';
import {RolesComponent} from './roles/roles.component';
import {PermissionsComponent} from './permissions/permissions.component';
import {CookieService} from 'angular2-cookie/services/cookies.service';
import {ReportAppComponent} from './report-app/report-app.component';
import {ReportTestComponent} from './report-test/report-test.component';
import {ReportSubscriptionComponent} from './report-subscription/report-subscription.component';
import {ReportDoubtComponent} from './report-doubt/report-doubt.component';
import {EnquiriesComponent, Reply2DialogBox} from './enquiries/enquiries.component';
import {DoubtComponent, ReplyDialogBox, RemarkDialogBox} from './doubt/doubt.component';
import {ProfileComponent} from './profile/profile.component';
import {SubjectPaperComponent} from './subject-paper/subject-paper.component';
import {StudentsComponent} from './students/students.component';
import {ChatusersComponent} from './chatusers/chatusers.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {PaymentComponent} from './payment/payment.component';
import {DoubtreplyComponent} from './doubtreply/doubtreply.component';
import {ForgotPasswordComponentComponent} from './forgot-password-component/forgot-password-component.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {OnlynumberDirective} from './directive/onlynumber.directive';
//import { GoogleComponent } from './google/google.component';
//import {AgmCoreModule}  from '@agm/core';
import {SalesComponent} from './sales/sales.component';
import {MatAutocompleteModule} from '@angular/material';
import {SaleDetailsComponent} from './sale-details/sale-details.component';
import {CouponsComponent} from './coupons/coupons.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {AddressComponent} from './address/address.component';
import {UnblockuserComponent} from './unblockuser/unblockuser.component';
import {MatProgressBarModule} from '@angular/material';
import {SettingsComponent} from './settings/settings.component';
// import { AgmCoreModule } from '@agm/core';
// import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
//import { GooglePlaceModule } from "ngx-google-places-autocomplete";
//import {MatProgressBarModule} from '@angular/material';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {SubjectExpertComponent} from './subject-expert/subject-expert.component';
import {EnquiryreplyComponent} from './enquiryreply/enquiryreply.component';
import {SnackbarComponent} from './snackbar/snackbar.component';
import {MatIconModule} from '@angular/material/icon';
import {MAT_SNACK_BAR_DATA} from '@angular/material';
// import { MatButtonModule, MatBottomSheetModule } from '@angular/material';
import {HelperService} from './helper.service';
import {RichTextEditorAllModule} from '@syncfusion/ej2-angular-richtexteditor';
// import { NgxEditorModule } from 'ngx-editor';
import {NgxTextEditorModule} from 'ngx-text-editor';
// import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
// import { QuillEditorModule } from 'ngx-quill-editor';
import {UserIdleModule} from 'angular-user-idle';
import {ModalModule} from 'ngx-bootstrap/modal';
import {GoogleComponent} from './google/google.component';


@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    FooterComponent,
    StudentComponent,
    TopmenuComponent,
    SyllabusComponent,
    GradeComponent,
    SubjectComponent,
    UserDialogBox,
    PriceDialogBox,
    StudentDialogBox,
    ReplyDialogBox,
    RemarkDialogBox,
    Reply2DialogBox,
    ChaptersComponent,
    TopicsComponent,
    VedioComponent,
    DashboardComponent,
    RecordComponent,
    GradesComponent,
    SubjectsComponent,
    SubscriptionComponent,

    ParentsComponent,

    LoginComponent,

    RedirectComponent,

    ChaptertestComponent,

    TopictestComponent,

    ChatComponent,

    NotificationComponent,

    UsersComponent,

    RolesComponent,

    PermissionsComponent,

    ReportAppComponent,

    ReportTestComponent,

    ReportSubscriptionComponent,

    ReportDoubtComponent,

    EnquiriesComponent,

    DoubtComponent,

    ProfileComponent,

    SubjectPaperComponent,

    StudentsComponent,

    ChatusersComponent,

    PageNotFoundComponent,

    PaymentComponent,

    DoubtreplyComponent,

    ForgotPasswordComponentComponent,

    ResetPasswordComponent,
    OnlynumberDirective,
    //GoogleComponent,

    SalesComponent,

    SaleDetailsComponent,

    CouponsComponent,

    AddressComponent,

    UnblockuserComponent,

    SettingsComponent,

    SubjectExpertComponent,

    EnquiryreplyComponent,

    SnackbarComponent,
    ExpiredDialogBox,
    GoogleComponent,
    SubjectComponent


  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    DataTablesModule,
    HttpClientModule,
    MatProgressBarModule,
    CKEditorModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    MatIconModule,
    //NgxTextEditorModule,
    //GooglePlaceModule,
    //    AgmCoreModule.forRoot({
    //    apiKey: 'AIzaSyBtA2W_uxykabFokdqJX3NoZTv7P18kLcg',
    //     libraries: ["places"]
    //  }),
    //    MatGoogleMapsAutocompleteModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    MatExpansionModule,
    NgxTextEditorModule,
    RichTextEditorAllModule,
    UserIdleModule.forRoot({idle: 600, timeout: 1, ping: null}),
    ModalModule.forRoot(),
    //NgxEditorModule,
    //  FroalaEditorModule.forRoot(),
    //  FroalaViewModule.forRoot(),
    //QuillEditorModule,
    RouterModule.forRoot([
      {path: '', redirectTo: '/login', pathMatch: 'full'},
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'redirect',
        component: RedirectComponent
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        component: DashboardComponent
      },
      {
        path: 'students/:sygrad',
        canActivate: [AuthGuard],
        component: StudentComponent
      },
      {
        path: 'appusers',
        canActivate: [AuthGuard],
        component: ParentsComponent
      },
      {
        path: 'syllabus',
        canActivate: [AuthGuard],
        component: SyllabusComponent
      },
      {
        path: 'grade/:syid',
        canActivate: [AuthGuard],
        component: GradeComponent
      },
      {
        path: 'subject/:grade/:syllabus_id/:gradeid',
        canActivate: [AuthGuard],
        component: SubjectComponent
      },
      {
        path: 'chapters/:sub/:syllabusid/:subjectgradeid/:subject_id/:gradeid',
        canActivate: [AuthGuard],
        component: ChaptersComponent
      },
      {
        path: 'topics/:chap/:syllabusid/:subject_id/:gradeid/:sub/:subjectgradeid',
        canActivate: [AuthGuard],
        component: TopicsComponent
      },
      {
        path: 'vedio/:topic/:status/:chap/:syllabusid/:subject_id/:gradeid/:sub/:subjectgradeid',
        canActivate: [AuthGuard],
        component: VedioComponent
      },
      {
        path: 'record',
        canActivate: [AuthGuard],
        component: RecordComponent
      },
      {
        path: 'grades',
        canActivate: [AuthGuard],
        component: GradesComponent
      },
      {
        path: 'subjects',
        canActivate: [AuthGuard],
        component: SubjectsComponent
      },
      {
        path: 'subscription',
        canActivate: [AuthGuard],
        component: SubscriptionComponent
      },
      {
        path: 'coupons',
        canActivate: [AuthGuard],
        component: CouponsComponent
      },
      {
        path: 'chaptertest/:id/:syllabusid/:subjectgradeid/:subject_id/:gradeid/:sub',
        canActivate: [AuthGuard],
        component: ChaptertestComponent
      },
      {
        path: 'topictest/:id/:chap/:syllabusid/:subject_id/:gradeid/:sub/:subjectgradeid',
        canActivate: [AuthGuard],
        component: TopictestComponent
      },
      {
        path: 'chat/:id',
        canActivate: [AuthGuard],
        component: ChatComponent
      },
      {
        path: 'notification',
        canActivate: [AuthGuard],
        component: NotificationComponent
      },
      {
        path: 'users',
        canActivate: [AuthGuard],
        component: UsersComponent
      },
      {
        path: 'roles',
        canActivate: [AuthGuard],
        component: RolesComponent
      },
      {
        path: 'permissions',
        canActivate: [AuthGuard],
        component: PermissionsComponent
      },
      {
        path: 'reports/appUsers',
        canActivate: [AuthGuard],
        component: ReportAppComponent
      },
      {
        path: 'reports/tests',
        canActivate: [AuthGuard],
        component: ReportTestComponent
      },
      {
        path: 'reports/subscription',
        canActivate: [AuthGuard],
        component: ReportSubscriptionComponent
      },
      {
        path: 'reports/doubts',
        canActivate: [AuthGuard],
        component: ReportDoubtComponent
      },
      {
        path: 'reports/sales',
        canActivate: [AuthGuard],
        component: SalesComponent
      },
      {
        path: 'order/:id',
        canActivate: [AuthGuard],
        component: SaleDetailsComponent
      },
      {
        path: 'enquiries',
        canActivate: [AuthGuard],
        component: EnquiriesComponent
      },
      {
        path: 'doubtlist',
        canActivate: [AuthGuard],
        component: DoubtComponent
      },
      {
        path: 'doubtreply',
        canActivate: [AuthGuard],
        component: DoubtreplyComponent
      },
      {
        path: 'profile',
        canActivate: [AuthGuard],
        component: ProfileComponent
      },
      {
        path: 'subject_paper/:id/:syllabus_id/:gradeid/:subject_id/:grade',
        canActivate: [AuthGuard],
        component: SubjectPaperComponent
      },
      {
        path: 'student/:id',
        canActivate: [AuthGuard],
        component: StudentsComponent
      },
      {
        path: 'chatusers',
        canActivate: [AuthGuard],
        component: ChatusersComponent
      },
      {
        path: 'payments',
        canActivate: [AuthGuard],
        component: PaymentComponent
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        component: SettingsComponent
      },
      {
        path: 'forgot',
        component: ForgotPasswordComponentComponent
      },
      {
        path: 'adminuser/reset_password/:id/:hash',
        component: ResetPasswordComponent
      },
      {
        path: 'address/:studentid/:packageid',
        canActivate: [AuthGuard],
        component: AddressComponent
      },
      {
        path: 'unblock/:parentid',
        canActivate: [AuthGuard],
        component: UnblockuserComponent
      },
      {
        path: 'experts_subject',
        canActivate: [AuthGuard],
        component: SubjectExpertComponent
      },
      {
        path: 'enquiryreply',
        canActivate: [AuthGuard],
        component: EnquiryreplyComponent
      },
      {path: '**', component: PageNotFoundComponent},

    ]),

  ],
  entryComponents: [SubjectComponent, ExpiredDialogBox, UserDialogBox, StudentComponent, PriceDialogBox, StudentDialogBox, ReplyDialogBox, Reply2DialogBox, RemarkDialogBox, SnackbarComponent, ExpiredDialogBox],

  providers: [CookieService, AuthGuard, {provide: MAT_SNACK_BAR_DATA, useValue: {}}, HelperService],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts